import React from "react";
import IconTag from "../layout/header/navbar/GetIcon";
// import PropTypes from "prop-types";
// import { withTranslation } from "react-i18next";
const MenuHelper = (props) => {
    return (
        <div className="sid-menu">
            {
                props?.data?.menu_class ? (
                    <span><IconTag iconTagName={props?.data?.menu_class} /></span>
                ) : props?.data?.menu_icon ? (
                    <span>
                        <img
                            loading="lazy" className={props?.className ? props?.className : null} src={props?.ftpPath + props?.data?.menu_icon?.base_path + props?.data?.menu_icon?.system_file_name}
                        />
                    </span>
                ) :
                    (props.footerMenu ? <div className="mobile-footer-menu"></div> : null)
            }
            {/* {
                props?.newLine ? <br /> : null
            } */}
            <span className="sm-f">
                {props.t(`${props?.data?.name?.toLowerCase()?.replace(/ /g, '_')}`)}
            </span>
        </div>
    )
}

// MenuHelper.propTypes = {
//     hotGameList: PropTypes.array,
//     t: PropTypes.func.isRequired,
// };

// export default withTranslation()(MenuHelper);
export default (MenuHelper);